export function gerarLinkWhatsApp(mensagem, telefone = "554192777432") {
    const mensagemCodificada = encodeURIComponent(mensagem);
    return `https://wa.me/${telefone}?text=${mensagemCodificada}`;
}